import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_TAGS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.tags'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};